import React from "react";
import { Link } from "react-router-dom";
import "../CSS/ErrorPaage.css";

const ErrorPage = () => {
  const errorStatus = "404";
  const errorMessage = "Page Not Found";
  const errorDescription = "The page you are looking for does not exist.";

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-animation">
          <div className="cube">
            <div className="face front">4</div>
            <div className="face back">0</div>
            <div className="face right">4</div>
          </div>
        </div>
        <h1>{errorStatus}</h1>
        <h2>{errorMessage}</h2>
        <p>{errorDescription}</p>
        <Link to="/" className="home-button">
          Go to Home
        </Link>
      </div>
      <div className="stars"></div>
      <div className="stars2"></div>
      <div className="stars3"></div>
    </div>
  );
};

export default ErrorPage;